import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export function getHeaders() {
  let headers = new HttpHeaders().append('Content-Type', 'application/json; charset=utf-8');
  return headers;
}

@Injectable({
  providedIn: 'root',
})
export class DemoService {
  uri = environment.urlApi.concat('/v1/demo');

  constructor(private http: HttpClient) { }

  admin() {
    return this.http.get<string>(this.uri.concat('/admin'), { headers: getHeaders() });
  }

  user() {
    return this.http.get<string>(this.uri.concat('/user'), { headers: getHeaders() });
  }

  getTeste1() {
    return this.http.get<string>(this.uri.concat('/teste1'), { headers: getHeaders() });
  }

  getTeste2() {
    return this.http.get<string>(this.uri.concat('/teste2'), { headers: getHeaders() });
  }
}